import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindAll } from 'redux-act'

import { buttons, actions as navigationActions } from '../ducks/navigation'
import { handleCodeChange } from '../ducks/common'
import defaultPage from '../hocs/defaultPage'
import RenderKatex from '../components/RenderKatex'
import Loader from '../components/Loader'

// Ace
// eslint-disable-next-line
import brace from 'brace'
import 'brace/mode/latex'
import 'brace/theme/monokai'

// Styled Components
import {
    PageWrap,
    EditorWindow,
    Editor,
    PreviewWindow,
    LoaderTint
} from './NewShare.styles'

class NewShare extends PureComponent {
    componentDidMount() {
        const { nav } = this.props
        nav.disableButton(buttons.remix)
    }

    render() {
        const { katexCode, onCodeChange, isSaving } = this.props

        return (
            <PageWrap>
                <EditorWindow>
                    <Editor
                        mode="latex"
                        theme="monokai"
                        onChange={onCodeChange}
                        value={katexCode}
                        width="100%"
                        height="100%"
                        showGutter={false}
                        showPrintMargin={false}
                        highlightActiveLine={false}
                        focus={true}
                    />
                </EditorWindow>

                <PreviewWindow>
                    <RenderKatex displayMode={true} renderErrors={true}>
                        {`$ ${katexCode} $`}
                    </RenderKatex>
                </PreviewWindow>

                {isSaving && (
                    <LoaderTint>
                        <Loader />
                    </LoaderTint>
                )}
            </PageWrap>
        )
    }
}

const NewSharePage = connect(
    ({ newShare }) => ({
        katexCode: newShare.katexCode,
        isSaving: newShare.isSaving
    }),
    dispatch => ({
        onCodeChange: katexCode => dispatch(handleCodeChange(katexCode)),
        nav: {
            ...bindAll(navigationActions, dispatch)
        }
    })
)(defaultPage(NewShare))

export default {
    component: NewSharePage,
    path: '/',
    exact: true
}



// WEBPACK FOOTER //
// ./src/pages/NewShare.js